var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAddCircle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5999 9.5999C12.5999 9.26853 12.3313 8.9999 11.9999 8.9999C11.6685 8.9999 11.3999 9.26853 11.3999 9.5999L11.3999 11.3999H9.5999C9.26853 11.3999 8.9999 11.6686 8.9999 11.9999C8.9999 12.3313 9.26853 12.5999 9.5999 12.5999H11.3999V14.3999C11.3999 14.7313 11.6685 14.9999 11.9999 14.9999C12.3313 14.9999 12.5999 14.7313 12.5999 14.3999V12.5999H14.3999C14.7313 12.5999 14.9999 12.3313 14.9999 11.9999C14.9999 11.6686 14.7313 11.3999 14.3999 11.3999H12.5999V9.5999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 3.3999C7.25025 3.3999 3.3999 7.25025 3.3999 11.9999C3.3999 16.7496 7.25025 20.5999 11.9999 20.5999C16.7496 20.5999 20.5999 16.7496 20.5999 11.9999C20.5999 7.25025 16.7496 3.3999 11.9999 3.3999ZM4.5999 11.9999C4.5999 7.913 7.913 4.5999 11.9999 4.5999C16.0868 4.5999 19.3999 7.913 19.3999 11.9999C19.3999 16.0868 16.0868 19.3999 11.9999 19.3999C7.913 19.3999 4.5999 16.0868 4.5999 11.9999Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAddCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Add Circle.74abe5ac.svg";
export { ForwardRef as ReactComponent };